import { combineFallbacks } from 'src/state'
import { useNFTCollections } from 'src/state/NFTCollections'
import { NFTTable } from 'src/pages/NFT/NFTTable'
import { NFT_ACTIVE } from 'src/consts/env'
import { filteredNFTParams } from 'src/utils'

export async function getServerSideProps({ query, res }) {
  if (!NFT_ACTIVE) return { notFound: true }

  const params = filteredNFTParams(query)

  const fallback = await combineFallbacks(useNFTCollections.getFallback(params))

  res.setHeader('Cache-Control', 'public, s-maxage=60')

  return {
    props: {
      fallback,
      params,
    },
  }
}

export default NFTTable
